/* eslint semi:0 */
import { node } from '../../utils/dom'
import { makeSafeFn } from '../../utils/fn'
import { external } from '../../utils/script'
import { SELECTORS } from '../../config/preRenderedSelectorsConfig'

const PLAYBUZZ_SCRIPT = 'playbuzz'

if (node(SELECTORS.PLAYBYZZ_CONTAINER)) {
  let playbuzz = external.load({ name: PLAYBUZZ_SCRIPT })
  let renderPlayBuzz = () => window.PlayBuzz.Feed.renderFeed()
  playbuzz(makeSafeFn(renderPlayBuzz))
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/playbuzz/playbuzzEmbedProvider.js